import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { VyDialog } from '../../../../components/new-design/feedback/VyDialog';
import { useDialog } from '../../../../hooks/use-dialog';

type DeletePlanDialogProps = {
  onSubmit: () => void;
  planName: string;
  disabled: boolean;
};

export const DeletePlanDialog: React.FC<DeletePlanDialogProps> = ({ onSubmit, disabled, planName }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <MenuItem disabled={disabled} onClick={handleOpen}>
        <ListItemIcon>
          <VyIcon
            icon="Delete"
            style={{
              transform: 'scale(0.8)',
            }}
          />
        </ListItemIcon>
        <ListItemText>Delete plan</ListItemText>
      </MenuItem>

      <VyDialog
        open={isDialogOpen}
        onClose={handleClose}
        label={`Delete Plan ${planName}`}
        cancelButtonText="Cancel"
        ctaText="Yes, delete"
        sx={{
          '& .MuiDialogContent-root': {
            borderBottom: 'none',
          },
        }}
        ctaButtonProps={{
          sx: {
            backgroundColor: '#FF2E57',
            '&:hover': {
              backgroundColor: '#c92041',
            },
          },
        }}
        onSubmit={onSubmit}
        dialogContentProps={{
          style: {
            maxWidth: '569px',
            minWidth: '569px',
          },
        }}
      >
        <Typography variant="body1">
          Are you sure you want to delete this plan? This action is final and cannot be reversed.
        </Typography>
      </VyDialog>
    </>
  );
};
